<div class="list-container">
    <div class="list-content">
        <div class="list-details">
            <h4 class="list-details-title">Add Location</h4>
            <div [formGroup]="locationForm">
                <div class="form-group">
                    <label>City</label>
                    <input formControlName="city" type="text" class="form-control">
                    <span class="err" *ngIf="locationForm.get('city').invalid && formSubmit">City required</span>
                </div>
                <div class="form-group">
                    <label>Country</label>
                    <input formControlName="country" type="text" class="form-control">
                    <span class="err" *ngIf="locationForm.get('country').invalid && formSubmit">Country required</span>
                </div>
                <div class="form-group">
                    <label>Province or State</label>
                    <input formControlName="provinceOrState" type="text" class="form-control">
                    <span class="err" *ngIf="locationForm.get('provinceOrState').invalid && formSubmit">Province or state required</span>
                </div>
                <div class="form-group">
                    <label>Postal Code</label>
                    <input formControlName="postalCode" type="text" class="form-control">
                    <span class="err" *ngIf="locationForm.get('postalCode').invalid && formSubmit">Postal/zip code required</span>
                </div>
                <div class="form-group isActive-checkbox">
                    <input formControlName="isActive" type="checkbox" class="">
                    <label>Active Status</label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" (click)="addLocation()" class="btn btn-primary">Add</button>
            </div>
        </div>
    </div>
</div>